import DialogSimple from './DialogSimple'

export { DialogSimple }
export default DialogSimple
